<nav>
  <div class="nav-wrapper">
      <a class="brand-logo" type="button" routerLink="">
          <img src="./assets/logos/logo.svg" alt="Nutrientes Criativos">
      </a>

      <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons">menu</i></a>

      <ul class="right hide-on-med-and-down">
        <li class="dashboard-navbar-item">
          <a class="dashboard-navbar-item--link" (click)="logout()">
            <i class="material-icons">input</i>
            Sair
          </a>
        </li>
      </ul>
  </div>
</nav>

<ul class="sidenav sidenav-items" id="mobile-demo">
  <li><a routerLink="/painel-pessoa-juridica">Resíduos</a></li>
  <li><a routerLink="/solicitantes-residuos">Solicitantes</a></li>
  <li><a routerLink="/cadastro-residuos">Cadastrar resíduos</a></li>

  <a class="btn btn-secondary waves-effect waves-light darken-3 text-white sidenav-logout" (click)="logout()">Sair</a>
</ul>

<div class="container-fluid">
  <div class="row">
    <div class="dashboard-sidebar col-md-2 hide-on-med-and-down">
      <ul class="dashboard-sidebar-items">
        <a class="dashboard-sidebar-item--link" routerLink="/painel-pessoa-juridica">
          <li class="col dashboard-sidebar-item dashboard-sidebar-item--link active">
            <i class="material-icons dashboard-sidebar-item--link-icon">home</i>
            Resíduos
        </li>
        </a>
        <a class="dashboard-sidebar-item--link" routerLink="/solicitantes-residuos">
        <li class="col dashboard-sidebar-item dashboard-sidebar-item--link">
            <i class="material-icons dashboard-sidebar-item--link-icon">group</i>
            Solicitantes
          </li>
        </a>
        <a class="dashboard-sidebar-item--link" routerLink="/cadastro-residuos">
          <li class="col dashboard-sidebar-item dashboard-sidebar-item--link">
            <i class="material-icons dashboard-sidebar-item--link-icon">add</i>
            Cadastrar resíduos
          </li>
        </a>
      </ul>
    </div>
    <main class="dashboard-content col-md-10 pt-3 px-4"><div style="position: absolute; inset: 0px; overflow: hidden; pointer-events: none; visibility: hidden; z-index: -1;" class="chartjs-size-monitor"><div class="chartjs-size-monitor-expand" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;"><div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0"></div></div><div class="chartjs-size-monitor-shrink" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;"><div style="position:absolute;width:200%;height:200%;left:0; top:0"></div></div></div>
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
        <h1 class="h2">Meus Resíduos</h1>
      </div>
      
      <h4 *ngIf="residues.length === 0">Não há resíduos cadastrados no momento</h4>

      <div *ngIf="residues.length > 0" class="row">
        <div class="col-12" *ngFor="let residue of residues">
          <div class="card">
            <div class="row m-0">
              <div class="col-4 card-image" [ngStyle]="{'background-image': residue.data.imagePath}"></div>
              <div class="col-8">
                <div class="card-content">
                  <span class="card-title"><b>{{residue.data.name}}</b></span>
                  <p>{{residue.data.description}}</p>
                </div>
                <div class="card-action">
                  <div class="card-labels">
                    <p><b>Setor:</b></p>
                    <span class="card-label" *ngFor="let sector of residue.data.sector">{{sector}}</span>
                  </div>
                  <div class="card-labels">
                    <p><b>Tipo:</b></p>
                    <span class="card-label" *ngFor="let type of residue.data.type">{{type}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
  
  
